import moment from 'moment';
import {
  MY_FILTER,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,
  TIPICON,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 筛选器默认配置
export const FILTER_DEFAULT_LIST_MAP = {
  MY_FILTER: {
    savePopupVisble: 0,
    key: MY_FILTER,
    value: '',
  },
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_GENRE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_GENRE_SELECT,
  },
  TIPICON: {
    savePopupVisble: 0,
    key: TIPICON,
    visibleinlist: 1,
    content: 'dbi_weixin_filter_info',
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [MY_FILTER]: {
    value: '',
  },
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_GENRE_SELECT]: {
    source: 'wechat_minigame',
    mainGenres: [],
    subGenres: [],
    minigame_genre: [],
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_LIST_MAP.MY_FILTER,
  FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,
  FILTER_DEFAULT_LIST_MAP.FILTER_GENRE_SELECT,
  FILTER_DEFAULT_LIST_MAP.TIPICON,
];
